class CarouselCollection extends HTMLElement {
  constructor() {
    super();
    this.collectionSwiper = null;
    this.target = this.querySelector(".swiper-section-container .swiper-wrapper");
    this.targetContainer = this.querySelector(".swiper-section-container");
    this.timeout;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.collectionSwiper = new Swiper(this.targetContainer, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 0.15
      },
      speed: 12000,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
    });
  }
}

if (!customElements.get("carousel-collection")) {
  customElements.define("carousel-collection", CarouselCollection);
}




